export default "<ng-material-multilevel-menu [configuration]='config' [items]='menuItems'>\n</ng-material-multilevel-menu>";